import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './NotificationToast.css';

/**
 * NotificationToast Component
 * Displays in-app toast notifications when FCM messages arrive in foreground
 */
const NotificationToast = ({ notification, onClose, onTrackClick }) => {
  const navigate = useNavigate();
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    // Auto-dismiss after 6 seconds
    const timer = setTimeout(() => {
      handleClose();
    }, 6000);

    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    setIsExiting(true);
    setTimeout(() => {
      onClose();
    }, 300); // Wait for exit animation
  };

  const handleClick = () => {
    // Track click for analytics
    if (notification.data?.history_id && onTrackClick) {
      onTrackClick(notification.data.history_id);
    }

    // Navigate based on deep link screen
    const screen = notification.deepLinkScreen || notification.data?.deep_link_screen;

    if (screen) {
      switch (screen) {
        case 'deal_details':
          navigate('/deal-details', { state: { dealId: notification.data?.dealId } });
          break;
        case 'payment_history':
        case 'payments':
          navigate('/payments');
          break;
        case 'dashboard':
          navigate('/dashboard');
          break;
        case 'profile':
          navigate('/my-profile');
          break;
        case 'subscription':
          navigate('/subscription');
          break;
        case 'tutors':
          navigate('/tutors');
          break;
        default:
          navigate('/dashboard');
      }
    }

    handleClose();
  };

  if (!notification) return null;

  return (
    <div className={`notification-toast ${isExiting ? 'notification-toast--exit' : ''}`}>
      <div className="notification-toast__content" onClick={handleClick}>
        <div className="notification-toast__icon">
          <img src="/bell-notification.svg" alt="notification" />
        </div>
        <div className="notification-toast__text">
          <div className="notification-toast__title">{notification.title}</div>
          <div className="notification-toast__body">{notification.body}</div>
        </div>
        <button 
          className="notification-toast__close" 
          onClick={(e) => {
            e.stopPropagation();
            handleClose();
          }}
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default NotificationToast;
